import React, { useState } from 'react';
import Dialog from '../../dialog';
import PatientPage from '../../../pages/patient';
import { PatientTabIdType } from '../../../../libs/patient';

interface ViewPatientDialogProps {
  isOpen: boolean;
  close: () => void;
  payload?: {
    patientId: number;
    tabId?: PatientTabIdType;
  };
}

const ViewPatientDialog: React.FC<ViewPatientDialogProps> = ({
  isOpen,
  close,
  payload
}) => {
  const [isInTransition, setIsInTransition] = useState(false);
  return (
    <Dialog
      isOpen={isOpen}
      onOpening={() => setIsInTransition(true)}
      onOpened={() => setIsInTransition(false)}
      canOutsideClickClose={!isInTransition}
      canEscapeKeyClose={!isInTransition}
      maxWidth="1600px"
      style={{
        width: '95%'
      }}
      onClose={close}
      className="pa-0 bg-light-gray4-important"
      forceScrollY
    >
      <PatientPage
        externalId={payload.patientId}
        externalTabId={payload.tabId}
        close={close}
      />
    </Dialog>
  );
};

export default ViewPatientDialog;
